import { Box, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select } from '@material-ui/core';

import { MenuItemType } from '@/components/shared/components/ApplicationList/ApplicationTypeSelect/types/MenuItemType';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { ApplicationType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

export const ApplicationTypeSelect = ({ selectedType, setSelectedType, menuItems }: ApplicationTypeSelect) => {
  const { isMobile } = useScreen();
  const { palette } = useCustomTheme();

  const onChangeProduct = (e) => setSelectedType(e.target.value);

  return (
    <>
      <Box display={'flex'} pb={2}>
        <Grid container justifyContent={isMobile ? 'center' : 'flex-start'}>
          <Grid item xs={isMobile ? 12 : 6}>
            <Paper elevation={0} style={{ backgroundColor: palette.grey[50] }}>
              <Box display={'flex'} px={2} mb={1} flexGrow={1}>
                <FormControl fullWidth>
                  <InputLabel>
                    <Font variant={'body1'} color={'textSecondary'}>
                      <Text tId={'TYPE_OF_APPLICATIONS'} />
                    </Font>
                  </InputLabel>
                  <Select onChange={onChangeProduct} value={selectedType}>
                    {menuItems.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        <Box display={'inline-flex'} alignItems={'center'}>
                          <i className={'material-icons-outlined'} style={{ fontSize: '16px', marginRight: '8px' }}>
                            {item.iconName}
                          </i>
                          <Text tId={item.labelTextId} />
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Divider />
    </>
  );
};

interface ApplicationTypeSelect {
  selectedType: ApplicationType;
  setSelectedType;
  menuItems: MenuItemType[];
}
